import React from "react";
import { Link } from "react-router-dom";
export default class ManualFolders extends React.Component {
  render() {
    const { structureItems, structure, wide } = this.props;

    let items = [];
    if (structureItems) {
      Object.entries(structureItems).forEach(([id, item]) => {
        if (String(item.node) === structure) items.push(item);
      });
      if (!items.length) {
        return null;
      }

      return (
        <>
          <div className="card card-custom mb-6">
            <div className="card-body px-5">
              <div className="row">
                {items.map((item) => {
                  if (String(item.node) !== structure) return null;
                  if (this.props.grid) {
                    return (
                      <div
                        key={item.id}
                        className={` my-2 col-lg-${wide ? "3" : "4"}`}
                      >
                        <Link
                          className="text-center"
                          to={`/manual/${item.id}/`}
                        >
                          <div className="mb-4">
                            <span className="fa fa-folder-o icon-3x text-muted text-hover-dark-50"></span>
                          </div>
                          <div className=" text-dark-50 text-hover-dark-75 ">
                            {item.name}
                          </div>
                        </Link>
                      </div>
                    );
                  } else {
                    return (
                      <div key={item.id} className="col-12">
                        <Link
                          className="d-block w-100 text-dark-50"
                          to={`/manual/${item.id}/`}
                        >
                          <div className="row py-2  border-bottom text-dark-50 bg-hover-light">
                            <div
                              style={{ wordBreak: "break-all" }}
                              className="col-lg-12 my-3"
                            >
                              <i className="fa text-muted   fa-folder-o mr-2"></i>
                              {item.name}
                            </div>
                          </div>
                        </Link>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </>
      );
    } else {
      return null;
    }
  }
}
